// extracted by mini-css-extract-plugin
module.exports = {"SideBar":"SideBar_SideBar__12De6","Fb":"SideBar_Fb__3fSUF","Envelope":"SideBar_Envelope__27U8E"};